import React from 'react';
import type {AIMessageGeneratorPromptAreaProps, ChatAskPrompt} from '../../../aiMessageGenerator/utils/types';
import AiAgentAsk from '../aiAgentAsk/AiAgentAsk';
import AiAgentInput from '../aiAgentInput/AiAgentInput';

interface AiAgentPromptAreaProps extends AIMessageGeneratorPromptAreaProps {
    pendingAsk: ChatAskPrompt | null;
    onClearAsk: () => void;
}

function AiAgentPromptArea({pendingAsk, onClearAsk, ...inputProps}: AiAgentPromptAreaProps) {
    if(pendingAsk) {
        return (
            <AiAgentAsk
                key={pendingAsk.id ?? pendingAsk.question}
                question={pendingAsk.question}
                options={pendingAsk.options}
                draftLoading={inputProps.draftLoading}
                onSelect={(value, label) => inputProps.onSubmitPrompt({
                    text: value,
                    displayText: label || value,
                })}
                onDismiss={onClearAsk}
            />
        );
    }

    return <AiAgentInput {...inputProps} />;
}

export default AiAgentPromptArea;
